<template>
  <label>
    <input
      :id="id"
      v-model="isChecked"
      :name="name"
      :value="value"
      type="radio"
    />
  </label>
</template>
<script>
export default {
  props: ['id', 'name', 'value', 'checked'],
  data() {
    return {
      isChecked: this.checked,
    }
  },
  watch: {
    isChecked: function(checkedValue) {
      this.$emit('RadioButtonEvent', checkedValue, this.id, this.name)
    },
    checked: function(value) {
      this.isChecked = value
    },
  },
}
</script>
